import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

class CancelProductsConfirmation extends Component {

	constructor(props){
		super(props);
		this.state = {
			whatDeleted: ''
		}
	}

	componentDidMount() {
		if(this.props.params.whatDeleted) {
			this.setState({
				whatDeleted: this.props.params.whatDeleted
			})
		}
	}

    render() {
		let { deletedOrderDetails } = this.props.state.order;
        return (
			<div>
				<h1 className="pageTitle">Cancel {this.state.whatDeleted === 'cancelOrder'?'Order':(this.state.whatDeleted === 'cancelProducts'?'Products':'')}</h1>
				{deletedOrderDetails &&
					<p className="orange" style={{marginBottom: 0}}>
						{this.state.whatDeleted === 'cancelOrder'
							?`Order ${this.props.state.order.deletedOrderDetails.orderNumber} has been cancelled`
							:(this.state.whatDeleted === 'cancelProducts'
								?`The following products have been cancelled from order ${this.props.state.order.deletedOrderDetails.orderNumber}`
								:null
							)
						}
					</p>
				}
				{deletedOrderDetails && this.state.whatDeleted === 'cancelProducts' && <table className="dataTable manageOrdersDeleteProductsRptTable" width="100%">
					<thead>
						<tr>
							<th className="delProd">Product</th>
							<th className="delProdDesc">Description</th>
							<th className="delProdQuantity">Quantity<br />Cancelled </th>
						</tr>
					</thead>
					<tbody>
						{deletedOrderDetails.items.map((item, index) => {
							return <tr key={index}>
								<td className="delProd">{item.item}</td>
								<td className="delProdDesc">{item.itemDescription}</td>
								<td className="delProdQuantity">{item.quantity}</td>
							</tr>
						})}
					</tbody>
				</table>
				}
				{deletedOrderDetails && <div>
                   	<p><Link to={"/manageorders"}>Return to Previous Screen</Link></p>
					<div className="clear" />
             	</div>
				}
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
})

CancelProductsConfirmation = connect(mapStateToProps, mapDispatchToProps)(CancelProductsConfirmation);
export default CancelProductsConfirmation;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/cancelProductsConfirmation.js